import { useEffect, useState } from "react";
import { useShowMore } from "../../../../hooks/useShowMore";
import { Container, BikesSection, BikeImage, BikeContent, Title, Description, Header, ButtonDiv, ShowMoreButton, PriceTag, } from "./styled";
import { bikeList } from "./bikesData";
import { StaggeredContainer, StaggeredItem } from "../../../animations/staggeredFadeIn";
import { useTranslation } from "react-i18next";
import { LINKS } from "../../../../config/links";

const useIsMobile = (maxWidth = 768) => {
    const query = `(max-width: ${maxWidth}px)`;

    const getMatches = () =>
        typeof window !== "undefined" ? window.matchMedia(query).matches : false;

    const [isMobile, setIsMobile] = useState(getMatches);

    useEffect(() => {
        if (typeof window === "undefined") return;

        const mql = window.matchMedia(query);
        const onChange = (e) => setIsMobile(e.matches);

        setIsMobile(mql.matches);

        if (mql.addEventListener) mql.addEventListener("change", onChange);
        else mql.addListener(onChange);

        return () => {
            if (mql.removeEventListener) mql.removeEventListener("change", onChange);
            else mql.removeListener(onChange);
        };
    }, [query]);

    return isMobile;
};

const BikeRental = () => {
    const { t } = useTranslation("bikesDescription");
    const isMobile = useIsMobile();
    const { showAll, handleToggle, buttonRef } = useShowMore();

    const contentToShow = showAll
        ? bikeList
        : isMobile
            ? bikeList.slice(0, 1)
            : bikeList.slice(0, 3);

    return (
        <Container id={LINKS.sections.bikesRental}>
            <StaggeredContainer>
                <StaggeredItem>
                    <Header>{t("header")}</Header>
                </StaggeredItem>

                <StaggeredItem>
                    {contentToShow.map((bike, i) => (
                        <BikesSection key={bike.id}>
                            <BikeImage
                                src={bike.image}
                                alt={t(`items.${bike.id}.title`)}
                                width={1600}
                                height={900}
                                loading={i < 3 ? "eager" : "lazy"}
                                decoding="async"
                            />
                            <BikeContent>
                                <Title>{t(`items.${bike.id}.title`)}</Title>
                                <Description>{t(`items.${bike.id}.description`)}</Description>
                                <PriceTag>{t(`items.${bike.id}.price`)}</PriceTag>
                            </BikeContent>
                        </BikesSection>
                    ))}
                </StaggeredItem>

                {bikeList.length > 3 && (
                    <ButtonDiv>
                        <ShowMoreButton onClick={handleToggle} ref={buttonRef}>
                            {showAll ? t("showLess") : t("showMore")}
                        </ShowMoreButton>
                    </ButtonDiv>
                )}
            </StaggeredContainer>
        </Container>
    );
};

export default BikeRental;